export function formatDateYMD(date: string | Date | undefined | null): string {
    if (!date) return '-';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (!(d instanceof Date) || isNaN(d.getTime())) return '-';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function parseDateParts(date: string | Date): {
    year: string; month: string; day: string;
    hour: string; minute: string; second: string;
    monthIndex: number;
} | null {
    if (typeof date === 'string') {
        // Try ISO formats: "2026-06-18T16:14:00" or "2026-06-18 16:14:00" or "2026-06-18"
        const m = date.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
        if (m) {
            const [, y, mo, d, h = '00', mi = '00', s = '00'] = m;
            return {
                year: y, month: mo, day: d,
                hour: h, minute: mi, second: s,
                monthIndex: parseInt(mo, 10) - 1,
            };
        }
        return null;
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
        const y = String(date.getFullYear());
        const mo = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const h = String(date.getHours()).padStart(2, '0');
        const mi = String(date.getMinutes()).padStart(2, '0');
        const s = String(date.getSeconds()).padStart(2, '0');
        return {
            year: y, month: mo, day: d,
            hour: h, minute: mi, second: s,
            monthIndex: date.getMonth(),
        };
    }
    return null;
}

export function formatPrintDate(date: string | Date | undefined | null, formatStr?: string): string {
    if (!date) return '';
    const p = parseDateParts(date);
    if (!p) return '';

    const year = p.year;
    const yy = year.slice(-2);
    const MM = p.month;
    const M = String(parseInt(p.month, 10));
    const dd = p.day;
    const dVal = String(parseInt(p.day, 10));
    const MMM = MONTH_NAMES[p.monthIndex];

    const hours = parseInt(p.hour, 10);
    const HH = p.hour;
    const h = hours % 12 || 12;
    const hh = String(h).padStart(2, '0');
    const mi = p.minute;
    const ss = p.second;
    const a = hours >= 12 ? 'PM' : 'AM';

    const format = formatStr || 'yyyy-MM-dd';

    // Replace tokens one at a time, removing matched token to prevent re-matching
    let result = format;
    const tokens: [RegExp, string][] = [
        [/^MMM/, MMM],
        [/^HH/, HH],
        [/^hh/, hh],
        [/^mm/, mi],
        [/^ss/, ss],
        [/^a/, a],
        [/^yyyy/, year],
        [/^yy/, yy],
        [/^MM/, MM],
        [/^M(?!\w)/, M],
        [/^dd/, dd],
        [/^d(?!\w)/, dVal],
    ];

    let output = '';
    while (result.length > 0) {
        let matched = false;
        for (const [pattern, replacement] of tokens) {
            const match = result.match(pattern);
            if (match && match.index === 0) {
                output += replacement;
                result = result.slice(match[0].length);
                matched = true;
                break;
            }
        }
        if (!matched) {
            output += result[0];
            result = result.slice(1);
        }
    }

    return output;
}

